import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslate } from 'react-admin';
import { BbPoolStock, bbGetPoolStocks } from '../../../services/blindBoxService';

export function SectionPoolStocks({
  refreshKey,
  sourceModule,
}: {
  refreshKey: number;
  sourceModule?: 'WHEEL' | 'BOX';
}) {
  const t = useTranslate();
  const [rows, setRows] = useState<BbPoolStock[]>([]);
  useEffect(() => {
    bbGetPoolStocks(sourceModule ? { sourceModule } : undefined)
      .then(setRows)
      .catch(() => setRows([]));
  }, [refreshKey, sourceModule]);
  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>rewardId</TableCell>
            <TableCell>{t('module.blindBox.colName')}</TableCell>
            <TableCell>remaining</TableCell>
            <TableCell>distributed</TableCell>
            <TableCell>totalPool</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((r) => (
            <TableRow key={r.rewardId}>
              <TableCell>{r.rewardId}</TableCell>
              <TableCell>{r.rewardName}</TableCell>
              <TableCell>{r.remaining}</TableCell>
              <TableCell>{r.distributed}</TableCell>
              <TableCell>{r.totalPool}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
